"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgLpg48 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 .5h48v48H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M17.25 13.858v-5.25h13.5v5.25m0 22.5v3.75h-13.5v-3.75m-.5-22.5h14.5a4 4 0 0 1 4 4v14.5a4 4 0 0 1-4 4h-14.5a4 4 0 0 1-4-4v-14.5a4 4 0 0 1 4-4Zm7.25 0v-2.625m-3.75 0h7.5m.656 16.465c-.355 1.933-1.986 3.334-3.965 3.406-1.851.074-3.495-1.01-4.008-2.621-.437-1.378-.093-2.89 1.054-4.624.15-.228.487-.644.786-1.003.013.063.029.126.046.185.13.445.299.875.656 1.017.216.087.56.092.946-.382.836-1.03 1.225-2.415 1.073-3.818 2.603 2.382 3.877 5.305 3.412 7.84Z", stroke: "currentColor" })] })) }))); };
exports.default = SvgLpg48;
